"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var boolean_expression_1 = require("./boolean-expression");
var filter_tree_operator_dto_1 = require("../dto/filter-tree-operator-dto");
var filter_dto_builder_1 = require("./filter-dto-builder");
var category_item_1 = require("./category-item");
var measure_item_1 = require("./measure-item");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
/**
 * Created by Hayk.Andriasyan on 5/31/2017.
 */
var Or = /** @class */ (function (_super) {
    __extends(Or, _super);
    function Or(_currentFilters) {
        var _this = _super.call(this, _currentFilters) || this;
        _this.operator = new filter_tree_operator_dto_1.FilterTreeOperatorDto(filter_dto_builder_1.FilterDtoBuilder.OPERATOR, filter_dto_builder_1.FilterDtoBuilder.OR_OPERATOR);
        return _this;
    }
    Or.prototype.orCategory = function (categoryPathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categoryPathHolderId);
        return new category_item_1.CategoryItem(this, categoryPathHolderId);
    };
    Or.prototype.orMeasure = function (measurePathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(measurePathHolderId);
        return new measure_item_1.MeasureItem(this, measurePathHolderId);
    };
    return Or;
}(boolean_expression_1.BooleanExpression));
exports.Or = Or;
//# sourceMappingURL=or.js.map